import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import styles from './ReportTableBodyRow.module.scss';

const ReportTableBodyRow = ({
  isClickable = false,
  isExpanded = false,
  children,
  className,
  extraRowProps,
  ...props
}) => {
  const rowRef = useRef(null);
  const invisibleRowRef = useRef(null);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (rowRef.current && invisibleRowRef.current) {
        const computeStyles = window.getComputedStyle(rowRef.current);
        invisibleRowRef.current.style.display = computeStyles.display;
      }
    });

    if (rowRef.current) {
      observer.observe(rowRef.current, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <tr
        ref={invisibleRowRef}
        className={styles.tableInvisibleBodyRow}
      />
      <tr
        ref={rowRef}
        {...props}
        className={cn(styles.tableBodyRow, className, {
          [styles.tableBodyRowClickable]: isClickable,
          [styles.tableBodyRowExpanded]: isExpanded,
        })}
      >
        {children}
      </tr>
    </>
  );
};

export default ReportTableBodyRow;
